<template>
    <div>
        <div v-if="checkIsCustomer(profileDior.memberType)" class="flip-card" :class="{ 'is-flipped': isFlipped }">
            <div class="flip-card-front" :class="getMemberLevel()">
                <img @click="flipCard()" class="ic-flip" src="../../../assets/img/03-profile/card/ic-rotate.png" />
                <div @click="oepnLink()">
                    <div class="title">{{lbl.profile.become_member}}</div>
                    <img class="logo-dior" src="../../../assets/img/03-profile/card/text-customer.png" />
                </div>
            </div>
            <div class="flip-card-back" :class="getMemberLevel()">
                <img @click="flipCard()" class="ic-flip" src="../../../assets/img/03-profile/card/ic-rotate.png" />
                <div class="bar-code-wrapper">
                    <vue-barcode id="barcode"
                        :value="profileDior.memberCode"
                        :options="objBarcodeConfig">
                    </vue-barcode>
                </div>
            </div>
        </div>
        <div v-else class="flip-card" :class="{ 'is-flipped': isFlipped }">
             <div class="flip-card-front" :class="getMemberLevel()">
                <img @click="flipCard()" v-if="profileDior.memberType.toLowerCase() != 'platinum'" class="ic-flip" src="../../../assets/img/03-profile/card/ic-rotate.png" />
                <img @click="flipCard()" v-else class="ic-flip" src="../../../assets/img/03-profile/card/ic-rotate-white.png" />
                <div class="level-wrapper">
                    <div>
                        <img class="ic-star" v-if="profileDior.memberType.toLowerCase() == 'white'" src="../../../assets/img/03-profile/card/white-star.png" />
                        <img class="ic-star" v-if="profileDior.memberType.toLowerCase() == 'silver'" src="../../../assets/img/03-profile/card/silver-star.png" />
                        <img class="ic-star" v-if="profileDior.memberType.toLowerCase() == 'gold'" src="../../../assets/img/03-profile/card/gold-star.png" />
                        <img class="ic-star" v-if="profileDior.memberType.toLowerCase() == 'platinum'" src="../../../assets/img/03-profile/card/platinum-star.png" />
                    </div>
                    <div>
                        <div class="text-status">{{lbl.profile.my_status}}</div>
                        <div class="text-level">{{profileDior.memberType}}</div>
                    </div>
                </div>
                <div class="my-point-wrapper">
                    <div class="text-title">{{lbl.profile.mypoint}}</div>
                    <div class="text-point">{{point | number_format}}</div>
                </div>
                <div class="point-expire-wrapper">
                    <div>{{lbl.profile.member_exp}} {{getExpiredDate()}}</div>
                </div>
            </div>
            <div class="flip-card-back" :class="getMemberLevel()">
                <img @click="flipCard()" v-if="profileDior.memberType.toLowerCase() != 'platinum'" class="ic-flip" src="../../../assets/img/03-profile/card/ic-rotate.png" />
                <img @click="flipCard()" v-else class="ic-flip" src="../../../assets/img/03-profile/card/ic-rotate-white.png" />
                <div class="level-wrapper">
                    <div>
                        <img class="ic-star" v-if="profileDior.memberType.toLowerCase() == 'white'" src="../../../assets/img/03-profile/card/white-star.png" />
                        <img class="ic-star" v-if="profileDior.memberType.toLowerCase() == 'silver'" src="../../../assets/img/03-profile/card/silver-star.png" />
                        <img class="ic-star" v-if="profileDior.memberType.toLowerCase() == 'gold'" src="../../../assets/img/03-profile/card/gold-star.png" />
                        <img class="ic-star" v-if="profileDior.memberType.toLowerCase() == 'platinum'" src="../../../assets/img/03-profile/card/platinum-star.png" />
                    </div>
                    <div>
                        <div class="text-status">{{lbl.profile.my_status}}</div>
                        <div class="text-level">{{profileDior.memberType}}</div>
                    </div>
                </div>
                <div class="bar-code-wrapper">
                    <vue-barcode id="barcode"
                        :value="profileDior.memberCode"
                        :options="objBarcodeConfig">
                    </vue-barcode>
                </div>
            </div>
        </div>
        <div v-if="!checkIsCustomer(profileDior.memberType)">
            <div class="next-level-wrapper" :class="getClassbyLevel()">
                <div class="next-level-item upgrade" v-if="profileDior.memberType != 'PLATINUM'">
                    <div>{{lbl.profile.upgrade_to}} <span class="level">{{nextLevel}}</span> </div>
                </div>
                <div class="next-level-item upgrade" v-else>
                    <div>{{lbl.profile.maintain}} <span class="level">PLATINUM</span></div>
                </div>
                <div class="next-level-item">
                    <div class="spendpoint-wrapper">
                        <div>{{lbl.profile.spent}}
                            {{profileDior.memberData.NextLevelAmount | number_format}}
                            <span v-if="localeCode == 1033" class="">{{lbl.profile.baht}}&nbsp;{{lbl.profile.and}}&nbsp;{{lbl.profile.purchased}}</span>
                            <span v-else class="">{{lbl.profile.baht}}{{lbl.profile.and}}{{lbl.profile.purchased}}</span>
                            {{profileDior.memberData.NextLevelFrequency | number_format}}
                            <span v-if="profileDior.memberType != 'PLATINUM'">{{lbl.profile.more_to}}</span>
                            <span v-if="profileDior.memberType == 'PLATINUM'">{{lbl.profile.more_to_plat}} <span class="plat">PLATINUM</span></span>
                        </div>
                    </div>
                    <div class="progress-bg" :class="getClassbyLevel()">
                        <div :style="{'width': progressWidth}" class="progress-active" :class="getClassbyLevel()"></div>
                        <div :style="{'left': progressWidthStar}" class="star-progress">
                            <img class="ic-star" v-if="profileDior.memberType.toLowerCase() == 'white'" src="../../../assets/img/03-profile/card/white-star.png" />
                            <img class="ic-star" v-if="profileDior.memberType.toLowerCase() == 'silver'" src="../../../assets/img/03-profile/card/silver-star.png" />
                            <img class="ic-star" v-if="profileDior.memberType.toLowerCase() == 'gold'" src="../../../assets/img/03-profile/card/gold-star.png" />
                            <img class="ic-star" v-if="profileDior.memberType.toLowerCase() == 'platinum'" src="../../../assets/img/03-profile/card/platinum-star.png" />
                        </div>
                    </div>
                    <div class="purchased-point-wrapper">
                        <div class="icon-purchase">
                            <img src="../../../assets/icon/ic-shopping-bag.png"/>
                            <div>{{nowPurchased}} / {{maxPurchased}} {{lbl.profile.time}}</div>
                        </div>
                        <div>{{maxlevelSpending | number_format}} {{lbl.profile.baht}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>

import Locale from "@/helper/locale/locale.js";
import VueBarcode from '@chenfengyuan/vue-barcode'; // https://github.com/fengyuanchen/vue-barcode/blob/master/README.md

export default {
    name: "Profile",
	components: {
        VueBarcode,
    },
    props: {
        profileDior: Object,
        point: {Number, default: 0},
        lbl: Object,
    },
    data: function () {
        return {

            isFlipped: false,
            showFront: true,

            objBarcodeConfig: null,
            nextLevel: "",
            maxlevelSpending: "",
            nowSpending: "",
            maxPurchased: "",
            nowPurchased: "",
            expireDate: "",
            progressWidth: "",
            progressWidthStar: "",

            localeCode: Locale.getLocaleCode(),
        };
    },
    created: function () {


    },
    mounted: function () {

        this.initialMemberData()
    },
    methods: {

        initialMemberData () {
            this.getNextLevel();
        },
        initialBarcode (color) {
            this.objBarcodeConfig = {
                width: 1,
                height: 50,
                margin: 0,
                displayValue: true,
                background: '',
                lineColor: color,
                fontSize: 15
            }
        },
        getNextLevel () {
            if (this.profileDior.memberType == 'C' || this.profileDior.memberType == 'D' || this.profileDior.memberType == 'D2') {
                this.initialBarcode("#44484b")
            }

            if (this.profileDior.memberType == 'WHITE') {
                this.initialBarcode("#44484b")
                this.nextLevel = this.lbl.profile.silver;
                this.maxlevelSpending = 10000;
                this.nowSpending = 10000 - this.profileDior.memberData.NextLevelAmount;
                this.maxPurchased = 2;
                this.nowPurchased = 2 - this.profileDior.memberData.NextLevelFrequency;
                this.progressWidth = (100/10000)*this.nowSpending;
                this.progressWidth = this.progressWidth > 100 ? 100+"%" : this.progressWidth+"%";
                console.log(this.progressWidth)
                this.progressWidthStar = ((100/10000)*this.nowSpending) - 2;
                this.progressWidthStar = this.progressWidthStar > 96 ? 96+"%" : this.progressWidthStar+"%";
            }
            if (this.profileDior.memberType == 'SILVER') {
                this.initialBarcode("#44484b")
                this.nextLevel = this.lbl.profile.gold
                this.maxlevelSpending = 60000;
                this.nowSpending = 60000 - this.profileDior.memberData.NextLevelAmount;
                this.maxPurchased = 3;
                this.nowPurchased = 3 - this.profileDior.memberData.NextLevelFrequency;
                this.progressWidth = (100/60000)*this.nowSpending;
                this.progressWidth = this.progressWidth > 100 ? 100+"%" : this.progressWidth+"%";
                this.progressWidthStar = ((100/60000)*this.nowSpending) - 2;
                this.progressWidthStar = this.progressWidthStar > 96 ? 96+"%" : this.progressWidthStar+"%";
            }
            if (this.profileDior.memberType == 'GOLD') {
                this.initialBarcode("#44484b")
                this.nextLevel = this.lbl.profile.platinum
                this.maxlevelSpending = 120000;
                this.nowSpending = 120000 - this.profileDior.memberData.NextLevelAmount;
                this.maxPurchased = 4;
                this.nowPurchased = 4 - this.profileDior.memberData.NextLevelFrequency;
                this.progressWidth = (100/120000)*this.nowSpending;
                this.progressWidth = this.progressWidth > 100 ? 100+"%" : this.progressWidth+"%";
                console.log("this.progressWidth",this.progressWidth)
                this.progressWidthStar = ((100/120000)*this.nowSpending) - 2;
                this.progressWidthStar = this.progressWidthStar > 96 ? 96+"%" : this.progressWidthStar+"%";
            }
            if (this.profileDior.memberType == 'PLATINUM') {

                this.initialBarcode("#ffffff")
                this.nextLevel = this.lbl.profile.hight_level
                this.maxlevelSpending = 120000;
                this.nowSpending = 120000 - this.profileDior.memberData.NextLevelAmount;
                this.maxPurchased = 4;
                this.nowPurchased = 4 - this.profileDior.memberData.NextLevelFrequency;
                this.progressWidth = (100/120000)*this.nowSpending;
                this.progressWidth = this.progressWidth > 100 ? 100+"%" : this.progressWidth+"%";
                this.progressWidthStar = ((100/120000)*this.nowSpending) - 2;
                this.progressWidthStar = this.progressWidthStar > 96 ? 96+"%" : this.progressWidthStar+"%";
            }

        },
        getExpiredDate () {
            var year = this.profileDior.memberData.MembershipPeriodEndDate.substring(0, 4);
            var month = this.profileDior.memberData.MembershipPeriodEndDate.substring(4, 6);
            var day = this.profileDior.memberData.MembershipPeriodEndDate.substring(6, 8);

            return day + "-" + month + "-" + year;
        },
        flipCard() {
            this.isFlipped = !this.isFlipped;
        },
        getMemberLevel() {
            switch (this.profileDior.memberType) {
                case "C":
                    return "customer-bg-card"
                case "D":
                    return "customer-bg-card"
                case "D2":
                    return "customer-bg-card"
                case "WHITE":
                    return "white-bg-card"
                case "SILVER":
                    return "silver-bg-card"
                case "GOLD":
                    return "gold-bg-card"
                case "PLATINUM":
                    return "platinum-bg-card"
                default:
                    break;
            }
        },
        getClassbyLevel () {
            switch (this.profileDior.memberType) {
                case "WHITE":
                    return "white"
                case "SILVER":
                    return "silver"
                case "GOLD":
                    return "gold"
                case "PLATINUM":
                    return "platinum"
                default:
                    break;
            }
        },
        oepnLink () {
            var localeCode = Locale.getLocaleCode()
            if (localeCode == 1033) {
                window.open("https://shop.dior.co.th/en/pages/loyalty")
            } else {
                window.open("https://shop.dior.co.th/pages/loyalty")
            }
        },
        checkIsCustomer (level) {
            if (level == "C") {
                return true;
            }
            if (level == "D") {
                return true;
            }
            if (level == "D2") {
                return true;
            }
            return false;

        }
    },
};
</script>
<style lang="scss" scoped>

.customer-bg-card {
    background-image: url("../../../assets/img/03-profile/card/bg-customer.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    color: #000000;
}
.white-bg-card {
    background-image: url("../../../assets/img/03-profile/card/bg-level-white.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    color: #000000;
}
.silver-bg-card {
    background-image: url("../../../assets/img/03-profile/card/bg-level-silver.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    color: #000000;
}
.gold-bg-card {
    background-image: url("../../../assets/img/03-profile/card/bg-level-gold.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    color: #000000;
}
.platinum-bg-card {
    background-image: url("../../../assets/img/03-profile/card/bg-level-platinum.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    color: white;
}
.flip-card {
    border-radius: 20px;
    display: inline-block;
    width: 100%;
    height: 210px;
    perspective: 1000px; /* set the perspective depth of the 3D space */
    transition: transform 0.6s ease; /* set the transition speed for the transform operation */
    position: relative;
    .ic-flip {
        width: 25px;
        height: 25px;
        position: absolute;
        right: 0;
        z-index: 1;
        margin-top: 5px;
        margin-right: 12px;
    }
}

.flip-card-front, .flip-card-back {
    border-radius: 20px;
    box-shadow: 0 2px 10px 0 rgba(122, 122, 122, 0.15);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    backface-visibility: hidden;
    transition: transform 1s ease; /* hide the backfaces of the card elements */

    .title {
        font-size: 14px;
        margin-top: 42px;
        margin-bottom: 8px;
        text-align: center;
    }
    .logo-dior {
        height: 98px;
        width: auto;
        margin: 0 auto;
        display: flex;
        margin: auto;
    }
}

.flip-card-front {
    transform: rotateY(0deg);
    padding: 7px 12px;

    .level-wrapper {
        display: flex;

        .ic-star {
            height: 33px;
            width: auto;
            margin-right: 6px;
        }
        .text-status {
            font-size: 10px;
        }
        .text-level {
            font-size: 24px;
            font-weight: bold;
            margin-top: -3px;
            line-height: 1;
        }
    }
    .my-point-wrapper {

        margin-top: 45px;
        text-align: center;

        .text-title {
            font-size: 14px;
            line-height: 1;
        }
        .text-point {
            margin-top: 2px;
            font-size: 24px;
            line-height: 1;
        }
    }
    .point-expire-wrapper {
        position: absolute;
        bottom: 12px;
        left: 0;
        right: 0;
        text-align: center;
        font-size: 12px;
    }
}

.flip-card-back {
    transform: rotateY(180deg);
    padding: 7px 12px;

    .level-wrapper {
        display: flex;

        .ic-star {
            height: 33px;
            width: auto;
            margin-right: 6px;
        }
        .text-status {
            font-size: 10px;
        }
        .text-level {
            font-size: 24px;
            font-weight: bold;
            margin-top: -3px;
            line-height: 1;
        }
    }
    .bar-code-wrapper {
        text-align: center;
        margin-top: 64px;
    }
}

/* Flip Card animations */
.flip-card.is-flipped .flip-card-front {
    transform: rotateY(-180deg);
}

.flip-card.is-flipped .flip-card-back {
    transform: rotateY(0deg);
}

.next-level-wrapper {
    // position: absolute;
    // bottom: 0;
    // left: 0;
    // right: 0;
    margin: auto;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
    // background-color: #fdfdfd;
    // height: 81px;
    padding: 3px 0;

    .next-level-item {
        // display: flex;
        font-size: 10px;
        padding: 8px 0px;
        line-height: 1.2;

        &.upgrade {
            font-size: 16px;

            .level {
                font-weight: bold;
            }
        }

        .spendpoint-wrapper {
            display: flex;
            align-items: center;
            font-size: 15px;

            .plat {
                font-weight: bold;
            }
        }
        .progress-bg {
            position: relative;
            margin-top: 10px;
            height: 10px;
            width: 100%;
            border-radius: 10px;
            &.white {
                border: solid 1px#D9D9D9;
            }
            &.silver {
                border: solid 1px#B9C2CF;
            }
            &.gold {
                border: solid 1px#E3D5C5;
            }
            &.platinum {
                border: solid 1px#3B3C3E;
            }

            .progress-active {
                position: absolute;
                border-radius: 10px;
                height: 8px;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                margin: auto 0;

                &.white {
                    background-color: #F2F2F2;
                }
                &.silver {
                    background-color: #DFE2E5;
                }
                &.gold {
                    background-color: #F4ECE3;
                }
                &.platinum {
                    background-color: #3B3C3E;
                }
            }
            .star-progress {
                position: absolute;
                top: -3px;
                bottom: 0;
                right: 0;
                margin: auto 0;
                .ic-star {
                    width: 14px;
                    height: 14px;
                }

            }

        }
        .purchased-point-wrapper {
            display: flex;
            justify-content: space-between;
            margin-top: 10px;
            font-size: 14px;
            border-bottom: 1px solid #EDEDED;
            padding-bottom: 20px;

            .icon-purchase {
                display: flex;
                align-items: center;

                img {
                    width: 18px;
                    height: 18px;
                    margin-right: 4px;
                }
            }
        }
        // .purchased-point-wrapper {
        //     display: flex;
        //     align-items: center;

        //     .purchased-icon {

        //         margin-left: 6px;
        //         height: 6px;
        //         width: 6px;
        //         border-radius: 100%;

        //         &.white {
        //             border: solid 0.4px#bababa;
        //         }
        //         &.silver {
        //             border: solid 0.4px#9faec2;
        //         }
        //         &.gold {
        //             border: solid 0.4px#e3d0bc;
        //         }
        //         &.platinum {
        //             border: solid 0.4px#222429;
        //         }

        //     }
        //     .purchased-icon-active {

        //         margin-left: 6px;
        //         height: 6px;
        //         width: 6px;
        //         border-radius: 100%;

        //         &.white {
        //             background-color: #bababa;
        //         }
        //         &.silver {
        //             background-color: #9faec2;
        //         }
        //         &.gold {
        //             background-color: #e3d0bc;
        //         }
        //         &.platinum {
        //             background-color: #222429;
        //         }

        //     }
        // }
    }
}
</style>
